import type { Attachment } from 'svelte/attachments';

export type ScrollActivityCallback = (isScrolling: boolean) => void;

/**
 *
 *
 *
 */
const SCROLL_SETTLE_DELAY_MS = 100;

/**
 *
 *
 *
 */
class ViewportScrollObserver {
    private callbacks = new Set<ScrollActivityCallback>();
    private settleTimeout: ReturnType<typeof setTimeout> | undefined;
    private isScrolling = false;
    private initialized = false;

    /**
 *
 *
 */
    observe(callback: ScrollActivityCallback): Attachment {
        return () => {
            this.initialize();
            this.callbacks.add(callback);
            callback(this.isScrolling);

            return () => {
                this.callbacks.delete(callback);
            };
        };
    }

    private initialize() {
        if (this.initialized || typeof window === 'undefined') return;

        window.addEventListener('scroll', this.handleScroll, { passive: true });
        this.initialized = true;
    }

    private handleScroll = (): void => {
        if (!this.isScrolling) {
            this.isScrolling = true;
            this.notify();
        }

        clearTimeout(this.settleTimeout);
        this.settleTimeout = setTimeout(() => {
            this.isScrolling = false;
            this.notify();
        }, SCROLL_SETTLE_DELAY_MS);
    };

    private notify(): void {
        for (const callback of this.callbacks) {
            callback(this.isScrolling);
        }
    }
}

export const viewportScrollObserver = new ViewportScrollObserver();
